import { render, staticRenderFns } from "./SendReferralLinkToUser.vue?vue&type=template&id=5603ff12&"
import script from "./SendReferralLinkToUser.vue?vue&type=script&lang=js&"
export * from "./SendReferralLinkToUser.vue?vue&type=script&lang=js&"
import style0 from "./SendReferralLinkToUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports